const MODAL = 'data-modal-video'
const MODAL_CLOSE = 'data-modal-video-close'
const MODAL_CONTENT = 'data-modal-video-content'
const MODAL_TRIGGER = 'data-modal-video-trigger'
const MODAL_DATA = 'data-modal-video-data'
const MODAL_CLASS = 'data-modal-video-class'

const $modal = document.querySelector(`[${MODAL}]`)
const $modalContent = document.querySelector(`[${MODAL_CONTENT}]`)
const $modalClose = document.querySelector(`[${MODAL_CLOSE}]`)
const $modalOuter = document.querySelector('.Modal-video-outer');

import globalCookies from './global-cookies'

function init(){
  const $modalTriggers = document.querySelectorAll(`[${MODAL_TRIGGER}]`)
  if (!$modalTriggers) return

  // bind modal closer
  if ($modalClose) {
    $modalClose.addEventListener('click', (e) => {
      hideModal();
    });    
  }

  // init modal triggers
  initModals()
}

function initModals() {
  jQuery(document).on('click', `[${MODAL_TRIGGER}][data-event-type="click"]`, (e) => {
    const modalContentContainer = jQuery(e.currentTarget).attr(MODAL_TRIGGER);
    openModal(modalContentContainer);
  })

  jQuery(document).on('mouseenter mouseleave', `[${MODAL_TRIGGER}][data-event-type="hover"]`, (e) => {
    const modalContentContainer = jQuery(e.currentTarget).attr(MODAL_TRIGGER);
    if (e.type === "mouseenter") {
      openModal(modalContentContainer, {x: e.pageX, y: e.pageY})
    } else {
      hideModal();
    }
  })
}

function getCookieConsent(vendor) {
  return window.axeptioSDK.hasAcceptedVendor(vendor)
}

/**
 * Populate and open modal from external JS
 */
function openModal(modalId, position) {
  const $modalData = document.querySelector(`[${MODAL_DATA}=${modalId}]`)
  const modalClass = $modalData.getAttribute(MODAL_CLASS);
  const iframe = $modalData.firstElementChild.dataset.iframe;
  var provider = $modalData.firstElementChild.dataset.provider;

  if (!provider && iframe && iframe.search('youtube') !== -1) {
    provider = 'youtube';
  } else if (!provider && iframe && iframe.search('vimeo') !== -1) {
    provider = 'vimeo';
  } else if (!provider) {
    console.error(`oEmbed video ressource with selector [${MODAL_DATA}=${modalId}] has no video provider`);
    return;
  }

  $modal.style.display = 'block';

  if ($modalData.dataset.showOverlay == "true") {
    showOverlay()
  }

  if (position) {
    setPosition(position);
  }

  if (modalClass) {
    $modal.classList.add(modalClass)
  }

  if (getCookieConsent(provider.toLowerCase())) {
    $modalContent.innerHTML = iframe
  } else {
    $modalContent.innerHTML = globalCookies.getConsentWarningHTML(provider.toLowerCase());
  }
}

function setPosition(position) {
  const modalWidth = $modalOuter.offsetWidth;
  const modalHeight = $modalOuter.offsetHeight;
  const viewportWidth = window.innerWidth;
  const isLeft = position.x <= (viewportWidth/2);

  $modalOuter.style.left = `${isLeft ? (position.x + 40) : (position.x - modalWidth - 40)}px`;
  $modalOuter.style.top = `${position.y - (modalHeight/2)}px`;
}

function showOverlay() {
  $modal.classList.add('show-overlay')
  $modalOuter.classList.add('Modal-outer')
}

function hideOverlay() {
  $modal.classList.remove('show-overlay')
  $modalOuter.classList.remove('Modal-outer')
}

function hideModal() {
  $modalContent.innerHTML = '';
  $modal.style.display = 'none';
}

export default { init }
